import { Soon } from "@/components/Soon";
import { Group, SettingRow } from "./parts";

const NOTIFICATIONS = [
  "Your turn",
  "Friend requests",
  "Comments on your presets",
  "Weekly earnings summary",
  "Product updates",
];

/** What Pax tells you about, by push and by email. */
export function NotificationsSection() {
  return (
    <div className="flex flex-col gap-6">
      <Group>
        {NOTIFICATIONS.map(title => (
          <SettingRow key={title} title={title} muted>
            <Soon />
          </SettingRow>
        ))}
      </Group>
    </div>
  );
}
